<template>
  <div class="page">
    <div class="page-header">
      <div class="container-fluid">
        <div class="header-content">
          <h1 class="header-title">{{ title }}</h1>
        </div>
      </div>
    </div>
    <div class="page-content container-fluid">
      <slot/>
    </div>
    <div class="last-component"></div>
  </div>
</template>

<script>
import TitleHeader from "@/components/layout/utils/TitleHeader";
export default {
  name: "FullPage",
  components: {TitleHeader},
  props : {
    title : {
      type : String,
      required : true,
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  background: var(--bg-gradient);
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  font-family: var(--font-family);
  transition: var(--transition-speed);
}

.page-header {
  background: linear-gradient(135deg, var(--accent-electric-blue), var(--accent-neon-purple));
  padding: 16px 0;
  margin-top: 0px;
  color: white;
  box-shadow: var(--card-shadow-hover);
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  // Add subtle animated background pattern
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
        radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.15) 0%, transparent 20%),
        radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.1) 0%, transparent 20%);
    opacity: 0.6;
    z-index: 0;
  }

  // Add subtle shine effect
  &::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
            to right,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.1) 50%,
            rgba(255, 255, 255, 0) 100%
    );
    transform: rotate(30deg);
    animation: shine 8s infinite;
    z-index: 0;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    z-index: 1;

    .header-title {
      font-size: 1.8rem;
      font-weight: 700;
      margin: 0;
      padding: 8px 0;
      position: relative;
      display: flex;
      align-items: center;
      animation: fadeIn 0.5s ease;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      letter-spacing: 0.5px;

      // Underline effect
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 60px;
        height: 3px;
        background: white;
        border-radius: 3px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
      }
    }
  }

  // Dark theme adjustments
  [data-theme='dark'] & {
    background: linear-gradient(135deg, var(--accent-electric-blue-dark), var(--accent-neon-purple-dark));
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);

    &::before {
      opacity: 0.3;
    }
  }
}

.page-content {
  padding-bottom: 24px;
}

.last-component {
  margin-bottom: 75px;
}

@keyframes shine {
  0% {
    transform: translateX(-100%) rotate(30deg);
  }
  20%, 100% {
    transform: translateX(100%) rotate(30deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
